export default {
  Settings: {
    HEADING: '{{group}} Group Settings',
    START_DATE: 'Start date: {{date}}',
    Team: {
      HEADING: 'Team',
    },
    Archive: {
      HEADING: 'Archive',
    },
    Billing: {
      HEADING: 'Billing',
      CHANGE_PLAN: 'Change Billing Plan',
      CHANGE_PLAN_CONFIRM:
        'Are you sure you want to change the billing plan from {{oldPlan}} with {{oldFreq}} billing to {{newPlan}} with {{newFreq}} billing?',
      CANCEL_PLAN: 'Cancel Subscription',
      CANCEL_PLAN_CONFIRM:
        'Are you sure you want to cancel your {{oldPlan}} subscription with {{oldFreq}} billing?',
    },
    AccountMapping: {
      HEADING: 'Account Mapping',
      SYSTEM_ACCOUNT:
        "Restrictions in Xero's API mean we cannot post to this account, please consider creating a new account code. Alternatively, you will be able to post as Draft and edit in Xero.",
      FX: 'FX Adjustments',
      FX_TOOLTIP:
        'Mayday will post any FX adjustments to this account code. It is commonly the Realised FX Gains and Losses account.',
    },
    IntercompanyBalances: {
      HEADING: 'Intercompany Balances',
      SAVED: 'Intercompany balance saved successfully.',
      ADD: 'Add Intercompany Balance',
      EDIT: 'Edit Intercompany Balance',
      NAMING:
        'Naming this intercompany balance will help to distinguish it from other intercompany balances involving the same entities.',
      DELETE: 'Delete Intercompany Balance',
      DELETE_CONFIRM:
        'Are you sure you want to delete the intercompany balance called {{name}}?',
      CLEAR_SEARCH: 'Clear search',
      AUTOCOMPLETE_PLACEHOLDER_ACCOUNT: 'Select an account',
      AUTOCOMPLETE_PLACEHOLDER_CONTACT: 'Select a contact',
      NO_BALANCES: 'No Intercompany Balances',
      NO_BALANCES_DESCRIPTION:
        "Looks like you haven't added any Intercompany Balances yet. No worries, let's get started!",
      NO_DATA: 'No data available',
      NO_DATA_DESCRIPTION:
        "We don't have data available for this date. Either use the date picker above to select a different date, or go to the Settings area and adjust your group's start date",
      GO_TO_SETTINGS: 'Go to Settings',
      PRODUCTS: 'Used on',
      CREDITOR: 'This entity should always be the creditor for this balance',
      ERROR: 'There was a problem saving. Please try again later.',
      CREATE: 'to create cross-currency balances.',
      New: {
        ENTITY: 'Select {{number}} entity',
        ACCOUNT: 'Account',
        CONTACT: 'Contact',
        OPTIONAL: 'Optional',
        NAME: 'Name',
        BRAG: 'Use this intercompany balance when reconciling transactions in BRAG',
        RECHARGER: 'Use this intercompany balance when posting recharges',
      },
      Products: {
        BRAG: 'BRAG isn’t active on your account. To activate it, go to the Products tab in Settings.',
        RECHARGER:
          'Recharger isn’t active on your account. To activate it, go to the Products tab in Settings.',
        EXISTING:
          'An intercompany balance between these two entities is already used for {{product}}. Consequently, you won’t be able to select this balance for {{product}}, but it will remain active in Balancer. Edit your other intercompany balances to make changes here.',
      },
      Error: {
        TITLE: 'Problem saving balance',
        BODY: 'There was a problem saving the balance. Please try again later',
      },
      ARAP_UNAVAILABLE: 'AR/AP matching is not available in your subscription',
      CROSS_CURRENCY:
        'Cross-currency intercompany balances are not included in your current plan.',
    },
    ConversionBalances: {
      HEADING: 'Conversion Balances',
      DESCRIPTION:
        "The values below are sourced from your organization's Trial Balance report for **{{date}}**. If you notice any discrepancies, please reach out to our support team via the live chat located in the bottom-right corner of the screen.",
      SUCCESS: 'Conversion balances saved successfully',
      FAILURE:
        'There was an error saving the conversion balances. Please try again or contact support',
    },
    RecLog: {
      HEADING: 'Reconciliation Log',
    },
    ExchangeRates: {
      HEADING: 'Exchange Rates',
      SOURCE: 'Source',
      ON: 'On',
      RATE: 'Rate',
      Remove: {
        HEADING: 'Remove FX rate override?',
        BODY_RECHARGER:
          'Are you sure you wish to remove the {{from}} to {{to}} override rate for {{range}}? Doing so could affect postings.',
        BODY_BALANCER:
          'Are you sure you wish to remove the {{from}} to {{to}} override rate for {{range}}? Doing so could affect balancer.',
      },
    },
    Products: {
      HEADING: 'Products',
      SUBHEADING: 'The below products are included in your current plan:',
      MODAL_COPY:
        '{{product}} is included in your current plan so this won’t affect the amount you get billed.',
      MODAL_COPY_NOT_INCLUDED: `{{product}} isn't included in your current plan, but can be purchased as an add-on. Go to`,
      SETTINGS_BILLING: `Settings > Billing`,
      TO_PURCHASE_ADDONS: `to purchase add-ons.`,
      NOT_INCLUDED_TOOLTIP: `{{product}} is not included in your current plan.`,
      ACTIVATE: 'Activate',
      Instructions: {
        recharger: 'Follow the steps below to set up Recharger for your group.',
        brag: 'Follow the steps below to set up BRAG for your group.',
        balancer: 'Follow the steps below to set up Balancer for your group.',
      },
    },
    Support: {
      HEADING: 'Support',
      TRIAL_END_TITLE: 'Trial End Date',
      TRIAL_END_SELECT: 'Select a new trial end date for this group.',
      MOVE_ORGANISATION_TITLE: 'Move Organisations to Another Group',
      MOVE_ORGANISATION_SELECT: 'Select organisation(s) to move:',
      MOVE_ORGANISATION_SELECT_NEW_GROUP: 'Select new group:',
      SAVE_TRIAL_END_SUCCESS: 'Trial end date saved successfully.',
      SAVE_TRIAL_END_FAILURE:
        'There was a problem saving. Please try again later.',
      NO_ACCESS: 'You do not have access to this page.',
      MOVE_ORGANISATION_MODAL_TITLE: 'Confirm Organisation Move',
      MOVE_ORGANISATION_MODAL_SUB_TITLE:
        'Moving Organisations [{{organisation}}] to {{group}}',
      MOVE_ORGANISATION_SUCCESS:
        '{{organisation}} successfully moved to {{group}}.',
      MOVE_ORGANISATION_FAILURE:
        'There was a problem moving organisations: {{reason}}',
      MOVE_ORGANISATION_DELETE_LOANS:
        'The following {{count}} intercompany balances will be deleted:',
      MOVE_ORGANISATION_MOVE_LOANS:
        'The following {{count}} intercompany balances will be moved to {{group}}:',
      MOVE_ORGANISATION_DELETE_RULES:
        'The following {{count}} rules will be archived:',
      MOVE_ORGANISATION_NO_CHANGES:
        'No intercompany balances will be moved or deleted by this operation 👍',
    },
  },
};
